exports.strings = {
    "accept": "Aceptar",
    "complete": "Completo",
    "cookiesMessage": "Utilizamos cookies para asegurarnos de brindarle la mejor experiencia. Si continúa utilizando esta aplicación, acepta el uso de cookies.",
    "decline": "Rechazar",
    "geolocationMessage": "Esta aplicación requiere servicios de ubicación que no están disponibles. Habilite los servicios de ubicación y actualice esta página para continuar.",
    "restartFromBeginning": "Reiniciar desde el principio",
    "resumingSession": "Reanudación de la sesión iniciada anteriormente...",
    "reviewAndSubmit": "Revisar y enviar",
    "support": "Reportar un problema",
    "termsOfService": "Términos y condiciones",
    "termsOfServiceURL": "https://www.attestiv.com/legal/terms-of-service",
    "verificationMessage": "Verifico que toda la información que he proporcionado es verídica y correcta. También acepto los...",

    // location accuracies
    "locationAccuracy": "Precisión de ubicación",
    "acceptable": "Aceptable",
    "fair": "Justo",
    "good": "Bueno",
    "great": "Excelente",
    "outstanding": "Pendiente",
    "poor": "Malo",

    // CaptureCamera.js
    "mediaCaptured": "El documento se subió exitosamente."
};
